import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetTeamsQuery = () => {
  const { teamController } = useAvApi();

  return useQuery({
    queryKey: ['teams'],
    queryFn: async () => {
      const { data } = await teamController.getV2Teams();

      return data;
    },
  });
};
